import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { ProductResponse } from 'src/app/models/product.model';
import { ProductionProcess, ProductionProcessProduct, ProductionProcessResponse } from 'src/app/models/production-process';
import { ResponseObject } from 'src/app/models/response-object.model';
import { ProductService } from 'src/app/services/product.service';
import { ProductionProcessService } from 'src/app/services/production-process.service';

interface ProductType {
  id: number;
  name: string;
  value: string;
}

interface ProductProcess {
  product: any;
  quantity: number;
  type: string;
  productId: number;
  percentage: number;
  productAssociate: number
}


@Component({
  selector: 'app-production-process',
  templateUrl: './production-process.component.html',
  styleUrls: ['./production-process.component.scss']
})
export class ProductionProcessComponent implements OnInit {
  creating = false;
  types: ProductType[] = [
    { id: 1, name: 'INPUT', value: 'Entrada' },
    { id: 2, name: 'OUTPUT', value: 'Salida' },
  ];

  filterWord: string = "";
  process: ProductionProcessResponse[] = [];
  filterProcess: ProductionProcessResponse[] = [];
  timeout = null;
  productsProcessIn: ProductProcess[] = [];

  showItem: number = null;
  loading = false;

  constructor(
    private productService: ProductService,
    private productionProcessService: ProductionProcessService,
    private toastService: ToastrService,
  ) { }

  ngOnInit(): void {
    this.getInitialData();
  }

  getInitialData() {
    this.getAllProcess();
  }

  getAllProcess() {
    this.loading = true;
    this.productionProcessService.getAllProductionProcessWithDetails().subscribe({
      next: (response: ResponseObject) => {
        this.process = response.data;
        this.filter();
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener los procesos productivos");
        this.loading = false;
      }
    });
  }

  filter() {
    this.filterProcess = this.process.filter((r) => {
      return r.process.name.toLowerCase().includes(this.filterWord.toLowerCase());
    });
  }


  closeModalCreate(created: boolean) {
    if (created) {
      this.getInitialData();
    }
    this.creating = false;
  }

  showDetials(item: ProductionProcess) {
    if (this.showItem!=null && this.showItem==item.id) {
      this.showItem = null;
    } else {
      this.showItem = item.id;
    }
  }

  getQuantityProductIn(products: ProductionProcessProduct[]): number {
    let count = 0
    products.forEach(element => {
      if (element.type=="INPUT") {
        count++;
      }
    });
    return count;
  }

  getQuantityProductOut(products: ProductionProcessProduct[]): number {
    let count = 0
    products.forEach(element => {
      if (element.type=="OUTPUT") {
        count++;
      }
    });
    return count;
  }
}
